import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useAuthentication } from '../../modules/auth/AuthenticationProvider';
import { BACKEND_URL } from '../backend-url';

type AssignGroupsData = {
    userSub: string;
    groupIds: string[];
}

export const useAssignGroupsRepository = () => {
    const { getJwtToken } = useAuthentication();
    const queryClient = useQueryClient();

    const mutation = useMutation({
        mutationFn: async (data: AssignGroupsData) => {
            const token = await getJwtToken();

            const response = await fetch(`${BACKEND_URL}/users/${data.userSub}/groups`, {
                method: 'PATCH',
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${token}`,
                },
                body: JSON.stringify({ groupIds: data.groupIds }),
            });

            if (!response.ok) {
                throw new Error('Failed to assign groups');
            }

            return await response.json();
        },
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['users'] });
        },
    });

    return {
        assignGroups: mutation.mutateAsync,
        ...mutation,
    };
};
